import { Link } from "react-router-dom";
import { services } from "../data/content";

export default function Services() {
  return (
    <section
      id="services"
      data-testid="services-section"
      className="relative px-6 md:px-12 py-20 md:py-28 border-b border-rule bg-paper"
    >
      <div className="max-w-[1600px] mx-auto">
        <div className="grid grid-cols-12 gap-6 md:gap-10 mb-14 md:mb-16">
          <div className="col-span-12 md:col-span-3">
            <div className="overline text-slate reveal">Also available</div>
            <div className="mono text-xs text-slate mt-3 reveal">— 03</div>
          </div>
          <div className="col-span-12 md:col-span-9">
            <h2
              data-testid="services-heading"
              className="serif text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-light tracking-tight leading-[1.05] text-ink reveal"
            >
              Three further modes of engagement
            </h2>
            <p className="mt-5 text-base md:text-lg text-ink/80 max-w-xl reveal">
              For businesses scaling, restructuring, or redesigning operations.
            </p>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8">
          {services.map((s) => (
            <ServiceCard key={s.slug} s={s} />
          ))}
        </div>
      </div>
    </section>
  );
}

function ServiceCard({ s }) {
  return (
    <Link
      to={`/services/${s.slug}`}
      data-testid={`service-${s.n}`}
      className="group block bg-paper border border-rule hover:border-ink/30 transition-colors duration-300 reveal"
    >
      <div className="aspect-[4/3] overflow-hidden">
        <img
          src={s.image}
          alt={s.alt}
          loading="lazy"
          className="w-full h-full object-cover img-editorial group-hover:scale-[1.03] transition-transform duration-700"
          data-testid={`service-image-${s.n}`}
        />
      </div>

      <div className="p-7 md:p-8">
        <div className="flex items-baseline justify-between mb-4">
          <span className="mono text-xs text-slate">{s.n}</span>
          <span className="overline text-mustard opacity-0 group-hover:opacity-100 transition-opacity">→</span>
        </div>

        <h3
          data-testid={`service-title-${s.n}`}
          className="serif text-xl md:text-2xl font-light tracking-tight leading-tight text-ink group-hover:text-mustard transition-colors"
        >
          {s.title}
        </h3>

        <p className="mt-3 text-sm leading-relaxed text-ink/70">
          {s.deck}
        </p>

        <div className="mt-5 pt-5 border-t border-rule flex flex-wrap gap-x-3 gap-y-1">
          {s.tags.map((t) => (
            <span
              key={t}
              className="text-[10px] tracking-wider uppercase text-slate"
            >
              {t}
            </span>
          ))}
        </div>
      </div>
    </Link>
  );
}
